import { render, staticRenderFns } from "./warnIndex.vue?vue&type=template&id=fb299bbe&scoped=true&"
import script from "./warnIndex.vue?vue&type=script&lang=js&"
export * from "./warnIndex.vue?vue&type=script&lang=js&"
import style0 from "./warnIndex.vue?vue&type=style&index=0&id=fb299bbe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb299bbe",
  null
  
)

export default component.exports